const querySelectorAsync = (selector, options = {}) => {
  const { signal, container = document } = options;
  const observeTarget = container === document ? document.body : container;

  return new Promise((resolve, reject) => {
    // Check if already aborted
    if (signal?.aborted) {
      reject(new Error("Query aborted"));
      return;
    }

    // Check if the element already exists
    const element = container.querySelector(selector);
    if (element) {
      resolve(element);
      return;
    }

    // Create a MutationObserver to watch for changes in the DOM
    const observer = new MutationObserver((mutations, observerInstance) => {
      const localElement = container.querySelector(selector);
      if (localElement) {
        resolve(localElement);
        observerInstance.disconnect(); // Stop observing once the element is found

        // Clear timeout if it exists
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
      }
    });

    // Start observing the container for changes
    observer.observe(observeTarget, {
      childList: true,
      subtree: true,
    });

    let timeoutId = null;

    // If signal provided, wait indefinitely and listen for abort
    if (signal) {
      const handleAbort = () => {
        observer.disconnect();
        reject(new Error(`Query for "${selector}" was aborted`));
      };

      signal.addEventListener("abort", handleAbort);
    } else {
      // If no signal, use 10s timeout for backward compatibility
      timeoutId = setTimeout(() => {
        observer.disconnect();
        reject(
          new Error(
            `Element with selector "${selector}" not found within the timeout period.`
          )
        );
      }, 10000); // 10 seconds timeout, adjust as needed
    }
  });
};

const clickElemOnExist = async (selector) => {
  (await querySelectorAsync(selector)).click();
};

export { querySelectorAsync };
export default clickElemOnExist;
